<template>
	<div class="cont_box">
		<div class="gall_box bai_box">
			<div class="gall_mbx">
				<el-breadcrumb separator=">">
					<el-breadcrumb-item>当前位置</el-breadcrumb-item>
					<el-breadcrumb-item>
						<span @click="gs_btn">近似种类</span>
					</el-breadcrumb-item>
					<el-breadcrumb-item>{{storeData.title}}</el-breadcrumb-item>
				</el-breadcrumb>
			</div>
			<div class="desc_box">
				<div class="desc_cont">
					<div class="desc_title">
						{{storeData.title}}
					</div>
					<div class="desc_time">
						发布时间：{{storeData.createTime}}
					</div>

					<div class="desc_p" v-html="storeData.content">

					</div>
					<!-- <div class="desc_img">
						<img oncontextmenu="return false;" ondragstart="return false;" :src="storeData.coverUrl" alt="" class="img">
					</div> -->
				</div>
			</div>
			
			
			
			<!--控制留言功能-->
			<!-- <div class="desc_lyb">
				<div class="desc_lyb_title">
					留言板
				</div>
				<div class="desc_lyb_txt">
					<textarea name="" v-model="push_paramet.content" id="" placeholder="请填写留言信息......"></textarea>
				</div>
				<div class="desc_lyb_fb">
					<div class="desc_lyb_input">
						<label for="">联系方式</label>
						<input type="text" v-model="push_paramet.concat" placeholder="请填写联系方式">
					</div>
					<div class="desc_lyb_btn" @click="lyb_btn">
						留言
					</div>
				</div>
				<div class="desc_lyb_list">
					<div class="desc_lyb_titles">
						全部留言 {{ly_data.records.length}}条
					</div>
					<div class="desc_lyb_item" v-for="(item,index) in ly_data.records" :key="index">
						<div class="desc_lyb_item_lef">
							<img src="../../assets/image/icon_lyb_tx@2x.png" alt="" class="tx_icon">
						</div>
						<div class="desc_lyb_item_rig">
							<div class="desc_lyb_item_name">
								{{item.name}}
							</div>
							<div class="desc_lyb_item_p">
								{{item.content}}
							</div>
							<div class="desc_lyb_item_time">
								{{item.createTime}}
							</div>
						</div>
					</div>
					<div class="desc_lyb_item_fot" :style="{'cursor': gd_flag?'pointer':'auto'}" @click="ck_btn">
						{{gd_flag?'查看更多':'没有更多信息了'}}
					</div>
				</div>
			</div> -->
		</div>
	</div>
</template>

<script>
	import headers from '@/components/header';
	import foot from '@/components/foot';
	export default {
		name: "UserDialong",
		data() {
			return {
				not_flag: true,
				tab_index: 'tpgs',
				storeData: '',
				paramet: {
					type: 'PICTURE',
					id: this.$route.query.id,
					page: 1,
					size: 10,
				},
				push_paramet: {
					concat: '', // 联系方式
					content: '', // 评论内容 
					id: this.$route.query.id,
					type: 'PICTURE',
				},
				ly_data: {
					records: []
				}, // 留言信息
			}
		},
		computed: {
			id() {
				return this.$route.query.id
			},
			gd_flag() {
				if (this.ly_data.current == this.ly_data.pages || this.ly_data.pages == 0) {
					return false
				} else {
					return true
				}
			}
		},
		filters: {

		},
		mounted() {
			this.init()
		},
		methods: {
			gs_btn() {
				this.$router.push({
					path: 'story_index'
				})
			},
			ck_btn() {
				if(this.gd_flag){
					this.paramet.page++
					this.ly_fn()
				}
			},
			lyb_btn() {
				if (!this.push_paramet.content) {
					this.$message({
						message: '评论内容不能为空哦',
						type: 'warning'
					});
					return
				}
				if (!this.push_paramet.concat) {
					this.$message({
						message: '联系方式不能为空哦',
						type: 'warning'
					});
					return
				}
				// if (this.push_paramet.concat.length!=11) {
				// 	this.$message({
				// 		message: '请输入正确的联系方式',
				// 		type: 'warning'
				// 	});
				// 	return
				// }
				this.$http.put(`/front/comment`,this.push_paramet).then(res => {
					this.$message({
						message: res.msg,
						type: 'success'
					});
					this.push_paramet.concat = ''
					this.push_paramet.content = ''
				})
			},
			init() {
				this.$http.get(`/front/picture/store/${this.id}`).then(res => {
					let data = res.data
					data.content = data.content.replace(/<img/g,'<div class="i_ks"></div><img style="width:100%;" class="i_imgs" oncontextmenu="return false;" ondragstart="return false;"')
					this.storeData = res.data
					this.paramet.page = 1
					this.ly_fn()
				})
			},
			ly_fn() {
				this.$http.get('/front/comment', this.paramet).then(res => {
					if(res.data.current==1){
						this.ly_data = res.data
					}else{
						let data = this.ly_data.records.conent(res.data.records)
						let datas = res.data
						datas.records = data
						this.ly_data = datas
					}
				})
			},
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
			}
		},
		components: {
			headers,
			foot,
		}
	}
</script>

<style lang="less" scoped>
	/deep/ .el-carousel__button {
		width: 8px;
		height: 8px;
		border-radius: 50%;
		background-color: rgba(255, 255, 255, .4);
	}

	/deep/ .is-active {
		.el-carousel__button {
			background-color: rgba(255, 255, 255, 1);
		}
	}

	/deep/ .i_imgs{
		display: block;
		position: relative;
	}
	/deep/ .i_ks{
		width: 81.9px;
		height: 78px;
		position: relative;
		// float: left;
		z-index: 1;
		top: 93px;
		left: 40px;
		background: url(../../assets/image/icon_logo_white.png) no-repeat;
		background-size: 100% 100%;
	}
	.desc_lyb {
		margin-top: 90px;
		.desc_lyb_title {
			font-size: 18px;
			color: #333333;
			margin-bottom: 23px;
			padding-left: 23px;
			font-weight: bold;
		}

		.desc_lyb_txt {
			width: calc(100% - 72px);
			box-sizing: border-box;
			margin: 0 auto;
			padding: 15px 31px;
			height: 90px;
			border-radius: 8px;
			background: #F5F5F5;

			textarea {
				width: 100%;
				height: 100%;
				border: none;
				resize: none;
				outline: none;
				background: transparent;
			}
		}

		.desc_lyb_fb {
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 0 36px 37px;
			box-sizing: border-box;
			margin: 23px auto 0;
			border-bottom: 1px dashed #E5E5E5;

			.desc_lyb_input {
				width: 349px;
				height: 53px;
				background: #F5F5F5;
				display: flex;
				padding-left: 30px;
				border-radius: 8px;

				label {
					color: #333333;
					font-size: 13px;
					line-height: 53px;
					margin-right: 30px;
				}

				input {
					flex: 1;
					height: 100%;
					background: transparent;
					outline: none;
					font-size: 13px;
				}
			}

			.desc_lyb_btn {
				width: 195px;
				height: 45px;
				background-color: #22AB67;
				border-radius: 22.5px;
				text-align: center;
				line-height: 45px;
				font-size: 18px;
				color: #fff;
				cursor: pointer;
			}
		}

		.desc_lyb_list {
			padding: 37px 36px 30px;
			margin-bottom: 30px;

			.desc_lyb_titles {
				color: #333333;
				font-size: 15px;
				margin-bottom: 37px;
			}

			.desc_lyb_item_fot {
				padding: 30px 0;
				text-align: center;
				color: #333333;
				font-size: 12px;
				cursor: pointer;
			}

			.desc_lyb_item {
				display: flex;
				padding-bottom: 23px;
				margin-top: 21px;
				border-bottom: 1px solid #E5E5E5;

				.desc_lyb_item_lef {
					width: 53px;
					height: 53px;
					margin-right: 23px;
					border-radius: 50%;

					.tx_icon {
						width: 100%;
						height: 100%;
						border-radius: 50%;
					}
				}

				.desc_lyb_item_rig {
					flex: 1;

					.desc_lyb_item_name {
						color: #333333;
						font-weight: bold;
						font-size: 12px;
						margin-bottom: 17px;
					}

					.desc_lyb_item_p {
						line-height: 2;
						font-size: 13px;
						color: #4A4A4A;
						margin-bottom: 30px;
					}

					.desc_lyb_item_time {
						font-size: 13px;
						color: #B8B8B8;
					}
				}
			}
		}
	}

	.desc_box {
		position: relative;

		.desc_cont {
			.desc_title {
				color: #000;
				font-size: 23px;
				font-weight: bold;
				margin-bottom: 30px;
				text-align: center;
			}

			.desc_time {
				border-bottom: 1px solid #E5E5E5;
				padding: 0 37px 15px;
				color: #676767;
				padding-bottom: 15px;
				text-align: right;
				font-size: 13px;
			}

			.desc_p {
				color: #4A4A4A;
				line-height: 2;
				padding: 28px 35px 30px;
				text-indent: 2em;
			}

			.desc_img {
				width: 600px;
				height: 450px;
				margin: 0 auto;

				.img {
					width: 100%;
					height: 100%;
					object-fit: cover;
				}
			}
		}
	}

	.gall_box {
		//width: 870px;
		width: 1200px;
		margin: 0 auto;

		.gall_mbx {
			margin: 0 0 30px;
			padding: 37px 23px 0;
		
			span {
				font-size: 13px;
				cursor: pointer;
			}
		}

		.gall_slt {
			display: flex;
			justify-content: flex-end;
			align-items: center;
			cursor: pointer;

			.icon {
				width: 20px;
				height: 20px;
				margin-right: 15px;
			}

			span {
				font-size: 15px;
				color: #22AB67;
			}
		}

		.gall_fy {
			margin: 30px 0 60px;

			.block {
				display: flex;
				justify-content: center;
			}
		}
	}
</style>
